export default __webpack_public_path__ + "static/media/collagen@2x.610bbf89.jpg";